import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "wPdfViewerBody"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "wPdfViewerEmpty"
};
const _hoisted_4 = {
  class: "wPdfViewerFooter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.visible,
    title: _ctx.title || _ctx.$t('pdfViewer.title'),
    width: '90vw',
    "append-to-body": true,
    "custom-class": "wPdfViewerDialog",
    onOnDialogClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('pdfViewer.close'),
      onAction: _ctx.onClose
    }, null, 8, ["label", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.pdfUrl ? (_openBlock(), _createElementBlock("iframe", {
      key: 0,
      src: _ctx.viewerUrl,
      class: "wPdfViewerFrame",
      frameborder: "0",
      allowfullscreen: ""
    }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('pdfViewer.empty')), 1))])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}